import formInputsTypes from '../simulatorConstant';
import tablierRideauMetalliqueData from './tablierRM';
import AxeManuelRMData from './axe/manuel';
import AxeMotoriseRMData from './axe/motorise';

import RMManuelCompletData from './complet/manuel';
import RMMotoriseCompletData from './complet/motorise';
import RideauMetalliqueMotorisationData from './motorisation';

const RideauMetalliqueData = {
	id: 'RMData',
	type: formInputsTypes?.SELECT_INPUT,
	label: 'Type de Fabrication',
	name: 'RMData',
	className: 'col-lg-12',
	nextStep: false,
	options: [
		{
			id: 11295,
			label: 'Tablier rideau métallique',
			value: 'RMData_Tablier',
			nextStep: tablierRideauMetalliqueData,
		},
		{
			id: 11290,
			label: 'Axe rideau métallique manuel',
			value: 'RMData_AxeManuel',
			nextStep: AxeManuelRMData,
		},
		{
			id: 11291,
			label: 'Axe rideau métallique motorisé',
			value: 'RMData_AxeMotorise',
			nextStep: AxeMotoriseRMData,
		},
		{
			id: 11292,
			label: 'Rideau métallique manuel complet',
			value: 'RMData_Manuelcomplet',
			nextStep: RMManuelCompletData,
		},
		{
			id: 11293,
			label: 'Rideau métallique motorisé complet',
			value: 'RMData_Motorisecomplet',
			nextStep: RMMotoriseCompletData,
		},
		{
			id: 11294,
			label: 'Moteur rideau métallique',
			value: 'RMData_Motorisation',
			nextStep: RideauMetalliqueMotorisationData,
		},
	],
};

export default RideauMetalliqueData;
